<template>
  <svg class="icon tick" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8">
    <path d="M11.452.243a.77.77 0 0 1 0 1.124l-6.39 6.39a.77.77 0 0 1-1.124 0L.743 4.562a.77.77 0 0 1 0-1.124.77.77 0 0 1 1.124 0L4.512 6.06 10.328.243a.77.77 0 0 1 1.124 0Z" fill="#fff"/>
  </svg>
</template>
